import type { EntryPoint, Shell } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { AiHtmlPromptApiKey } from './publicApiKey';
import { createAiHtmlPromptApi } from './createAiHtmlPromptApi';

export const AiHtmlPromptApiEntryPoint: EntryPoint = {
  name: 'AiHtmlPromptApiEntryPoint',
  getDependencyAPIs() {
    return [EditorAPIKey];
  },
  declareAPIs() {
    return [AiHtmlPromptApiKey];
  },
  attach(shell: Shell) {
    shell.contributeAPI(AiHtmlPromptApiKey, () => createAiHtmlPromptApi(shell));
  },
};
